import { motion } from "framer-motion";
import { Container } from "./shared";

export function LogoCloud() {
  return (
    <section className="py-16 md:py-20 bg-neutral-50 dark:bg-neutral-900/50">
      <Container>
        <div className="text-center mb-12">
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
            className="text-muted-foreground text-lg"
          >
            Join creators building on Lint
          </motion.p>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.1 }}
          viewport={{ once: true }}
          className="grid grid-cols-3 gap-8 max-w-3xl mx-auto text-center"
        >
          <div>
            <div className="text-4xl md:text-5xl font-bold text-foreground">$3.2K+</div>
            <div className="text-sm text-muted-foreground mt-2">Creator Earnings</div>
          </div>
          <div>
            <div className="text-4xl md:text-5xl font-bold text-foreground">180+</div>
            <div className="text-sm text-muted-foreground mt-2">Students Enrolled</div>
          </div>
          <div>
            <div className="text-4xl md:text-5xl font-bold text-foreground">24</div>
            <div className="text-sm text-muted-foreground mt-2">Products Live</div>
          </div>
        </motion.div>
      </Container>
    </section>
  );
}
